<template>
  <router-link
    :to="{ name: 'user.author.profile', params: {id: user.id} }"
    class="author"
  >
    <div class="author__infos">
      <picture
        class="author__avatar"
        :style="{ backgroundImage: `url(${user.avatar})` }"
      ></picture>
      <div>
        <h2 class="author__name text-truncate">{{ user.name }}</h2>
        <h3 class="author__cases">{{ user.teacher_cases }}</h3>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  props: {
    user: { type: Object, default: () => ({}) }
  }
}
</script>

<style scoped lang="scss">
  .author {
    display: flex;
    flex-direction: column;
    position: relative;
    box-shadow: 0px 4px 3px 1px rgba(#454550, .1);
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(#000, .1);

    &:hover { border-color: #ff8000 }

    &__infos {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      // background: lighten(#000, 95);
      padding: 10px;
    }

    &__name,
    &__cases {
      font-family: 'Poppins';
      color: #000;
    }

    &__name {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 5px;
    }

    &__avatar {
      flex: 0 0 auto;
      display: block;
      width: 55px;
      height: 55px;
      border-radius: 100%;
      margin-right: 10px;
      background-position: center center;
      background-size: cover;
    }

    &__cases {
      color: lighten(#000, 30);
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: .3px;
    }
  }
</style>